import React, { FC } from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { ESpacing, ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

interface IDemoCompletionDetailHeaderProps {
  title: string;
  onCopy: () => void;
}

const DemoCompletionDetailHeader: FC<IDemoCompletionDetailHeaderProps> = ({ title, onCopy }) => {
  const { t } = useTranslation();
  return (
    <StyledContainer>
      <UIText typography={ETypography.TEXT_XL_SEMIBOLD}>{title}</UIText>
      <StyledCopyContainer onClick={onCopy}>
        <StyledCopyText typography={ETypography.TEXT_L_MEDIUM}>{t('Copy')}</StyledCopyText>
      </StyledCopyContainer>
    </StyledContainer>
  );
};

export default DemoCompletionDetailHeader;

const StyledContainer = styled.div`
  padding: ${ESpacing.M}px ${ESpacing.L}px;
  background-color: ${({ theme }) => theme.themeColors.background.subtle};
  display: flex;
  justify-content: space-between;
`;

const StyledCopyContainer = styled.div``;

const StyledCopyText = styled(UIText)`
  color: ${({ theme }) => theme.themeColors.primary};
  cursor: pointer;
`;
